<template>
    <div class="flex justify-center items-center pt-12">
        <v-form name="formSetting"
                class="shadow-box border border-gray-100 bg-white rounded-md shadow-md"
                style="border:1px solid #e0e0e0; padding:10px; width:100%; max-width:900px; margin:0 auto;">
            <Tabs value="0" scrollable>
                <TabList>
                    <Tab value="0">{{ __('Basic data') }}</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel value="0">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-8 justify-items-center">
                            <FormCalendar fieldName="test_current_date"
                                          label="Test current date"
                                          size="4"
                                          :isFormDisabled="false"
                                          v-model:field="config.test_current_date"
                                          class="w-full h-12 text-base" />

                            <FormInputNumber fieldName="info_timeout"
                                             label="Czas wyświetlania informacji (sekundy, 0-120)"
                                             size="4"
                                             :min="0"
                                             :max="120"
                                             :minFractionDigits="0"
                                             :maxFractionDigits="0"
                                             v-model:field="config.info_timeout"
                                             class="w-full h-12 text-base" />

                            <FormInputNumber fieldName="error_timeout"
                                             label="Czas wyświetlania błędu (sekundy, 0-120)"
                                             size="4"
                                             :min="0"
                                             :max="120"
                                             :minFractionDigits="0"
                                             :maxFractionDigits="0"
                                             v-model:field="config.error_timeout"
                                             class="w-full h-12 text-base" />
                        </div>
                    </TabPanel>
                </TabPanels>
            </Tabs>
            <div style="margin-top:20px;text-align:right;margin-left:auto;margin-right:auto;">
                <hr style="margin-bottom:20px">
                <div class="grid grid-cols-2 gap-4">
                    <Button @click="saveData"
                            :disabled="config.processing"
                            style="margin:0 5px"
                            severity="success">
                        {{ __('Save') }}
                    </Button>
                    <Button @click="cancelData"
                            :disabled="config.processing"
                            style="margin:0 5px"
                            severity="secondary">
                        {{ __('Cancel') }}
                    </Button>
                </div>
            </div>
        </v-form>
    </div>
</template>

<script setup>
import { ref } from 'vue'

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormCalendar from '@crud/FormCalendar.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import Button from 'primevue/button';
import { useForm, router } from '@inertiajs/vue3';
import { __, convertDate } from '@pages/Helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    data: Object,
})

const config = ref(props.data)

// -----------------------------------------------------

const saveData = () => {
    useForm({
        ...config.value,
        'test_current_date': convertDate(config.value.test_current_date),
        'is_manager_update': config.value.is_manager_update,
        'info_timeout': config.value.info_timeout,
        'error_timeout': config.value.error_timeout
    }).post(route('set-setting'), {
        preserveState: true,
        preserveScroll: true,
        onError: (errors) => {
            console.error(errors)
        },
        onSuccess: () => {
        },
        onFinish: () => {
        }
    })
}

// -----------------------------------------------------

const cancelData = () => {
    router.get(route('system-start'));
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped>

</style>
